import { apiPath } from "@/api/api-path"
import store from "@/store/index"
import api from "./service"

// --------------------------------------------------------------------------------
// DASHBOARD
// --------------------------------------------------------------------------------
export async function getDashboard() {
  return api
    .get(apiPath.getDashboard, {})
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// --------------------------------------------------------------------------------
// SERVER
// --------------------------------------------------------------------------------
export async function getVeeamServer(filter) {
  return api
    .get(apiPath.getVeeamServer, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function addVeeamServer(request, veeam) {
  return api
    .post(apiPath.addVeeamServer, request, {
      params: {
        veeamId: veeam,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function editVeeamServer(id, request, veeam) {
  return api
    .put(apiPath.editVeeamServer + id, request, {
      params: {
        veeamId: veeam,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteVeeamServer(id, veeam) {
  return api
    .delete(apiPath.deleteVeeamServer + id, {
      params: {
        veeamId: veeam,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// ----------
// REPOSITORY
// ----------
export async function getRepositoryList(filter) {
  return api
    .get(apiPath.getRepositoryList, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) {
        store.dispatch("app/setVeeamStatus", true)
        return response.data.data
      }
    })
    .catch((error) => {
      store.dispatch("app/setVeeamStatus", false)
      console.error(error)
    })
}

export async function getRepositoryStatusList(filter) {
  return api
    .get(apiPath.getRepositoryStatusList, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) {
        store.dispatch("app/setVeeamStatus", true)
        return response.data.data
      }
    })
    .catch((error) => {
      store.dispatch("app/setVeeamStatus", false)
      console.error(error)
    })
}

export async function getRepositoryById(id, veeamId) {
  return api
    .get(apiPath.getRepositoryById + id, {
      params: {
        veeamId,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function createRepository(veeamId, request) {
  return api
    .post(apiPath.createRepository, request, {
      params: {
        veeamId,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateRepository(id, veeamId, request) {
  return api
    .put(apiPath.updateRepository + id, request, {
      params: {
        veeamId,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteRepository(id, veeamId) {
  return api
    .delete(apiPath.deleteRepository + id, {
      params: {
        veeamId,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// ----------
// CREDENTIAL
// --------------------------------------------------------------------------------
export async function getVeeamCredential(filter) {
  return api
    .get(apiPath.getVeeamCredential, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) {
        store.dispatch("app/setVeeamStatus", true)
        return response.data.data
      }
    })
    .catch((error) => {
      store.dispatch("app/setVeeamStatus", false)
      console.error(error)
    })
}

export async function createVeeamCredential(request, veeam) {
  return api
    .post(apiPath.getVeeamCredential, request, {
      params: {
        veeamId: veeam,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function editVeeamCredential(id, request, veeam) {
  return api
    .put(apiPath.editVeeamCredential + id, request, {
      params: {
        veeamId: veeam,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function changePasswordVeeamCredential(id, request, veeam) {
  return api
    .post(apiPath.changePasswordVeeamCredential.replace("{id}", id), request, {
      params: {
        veeamId: veeam,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function changeRootPasswordVeeamCredential(id, request, veeam) {
  return api
    .post(
      apiPath.changeRootPasswordVeeamCredential.replace("{id}", id),
      request,
      {
        params: {
          veeamId: veeam,
        },
      }
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteVeeamCredential(id, veeam) {
  return api
    .delete(apiPath.deleteVeeamCredential + id, {
      params: {
        veeamId: veeam,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// --------------------------------------------------------------------------------
// VEEAM
// --------------------------------------------------------------------------------
export async function getVeeamList(filter) {
  return api
    .get(apiPath.getVeeamList, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function addVeeam(request) {
  return api
    .post(apiPath.getVeeamList, request, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function editVeeam(id, request) {
  return api
    .put(apiPath.editVeeam + id, request, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteVeeam(id) {
  return api
    .delete(apiPath.deleteVeeam + id, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// --------------------------------------------------------------------------------
// Job
// --------------------------------------------------------------------------------
export async function getVmInventoryListByName(filter, vmName) {
  return api
    .get(apiPath.vmInventory + vmName, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data?.data
    })
    .catch((error) => {
      console.error(error)

      throw error
    })
}

export async function getJobList(filter) {
  return api
    .get(apiPath.getJobs, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) {
        store.dispatch("app/setVeeamStatus", true)
        return response.data
      }
    })
    .catch((error) => {
      store.dispatch("app/setVeeamStatus", false)
      console.error(error)
    })
}

export async function getBackupList(filter) {
  return api
    .get(apiPath.getJobsStates, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) {
        store.dispatch("app/setVeeamStatus", true)
        return response.data
      }
    })
    .catch((error) => {
      store.dispatch("app/setVeeamStatus", false)
      console.error(error)
    })
}

export async function getBackupStateById(id, filter) {
  return api
    .get(apiPath.getJobsStatesById + id, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getBackupById(id, filter) {
  return api
    .get(apiPath.getBackupById + id, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function createBackup(request, veeamId) {
  return api
    .post(apiPath.createVeeamBackup, request, {
      params: {
        veeamId: veeamId,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function editBackup(request, id, veeamId) {
  return api
    .put(apiPath.updateVeeamBackup + id, request, {
      params: {
        veeamId: veeamId,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function deleteJob(id, veeamId) {
  return api
    .delete(apiPath.deleteJob + id, {
      params: {
        veeamId,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// --------------------------------------------------------------------------------
// Inventory
// --------------------------------------------------------------------------------
export async function getInventoryBrowsers(filter) {
  return api
    .get(apiPath.getInventoryBrowsers, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) {
        store.dispatch("app/setVeeamStatus", true)
        return response.data
      }
    })
    .catch((error) => {
      store.dispatch("app/setVeeamStatus", false)
      console.error(error)
    })
}

export async function startBackup(request, veeamId) {
  const path = apiPath.startVeeamBackup.replace("{id}", request)
  return api
    .post(
      path,
      {},
      {
        params: {
          veeamId: veeamId,
        },
      }
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function stopBackup(request, veeamId) {
  const path = apiPath.stopVeeamBackup.replace("{id}", request)
  return api
    .post(
      path,
      {},
      {
        params: {
          veeamId: veeamId,
        },
      }
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function enableBackup(request, veeamId) {
  const path = apiPath.enableVeeamBackup.replace("{id}", request)
  return api
    .post(
      path,
      {},
      {
        params: {
          veeamId: veeamId,
        },
      }
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function disableBackup(request, veeamId) {
  const path = apiPath.disableVeeamtBackup.replace("{id}", request)
  return api
    .post(
      path,
      {},
      {
        params: {
          veeamId: veeamId,
        },
      }
    )
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// --------------------------------------------------------------------------------
// Restore
// --------------------------------------------------------------------------------
export async function getRestorePoint(filter) {
  return api
    .get(apiPath.getRestorePoint, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) {
        store.dispatch("app/setVeeamStatus", true)
        return response.data
      }
    })
    .catch((error) => {
      store.dispatch("app/setVeeamStatus", false)
      console.error(error)
    })
}

export async function restoreEntireVm(request, veeamId) {
  return api
    .post(apiPath.restoreEntireVm, request, {
      params: {
        veeamId: veeamId,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

// --------------------------------------------------------------------------------
// Backup
// --------------------------------------------------------------------------------
export async function getBackupObjectList(filter) {
  return api
    .get(apiPath.getBackupObject, {
      params: {
        ...filter,
      },
    })
    .then((response) => {
      if (response.status === 200) {
        store.dispatch("app/setVeeamStatus", true)
        return response.data
      }
    })
    .catch((error) => {
      store.dispatch("app/setVeeamStatus", false)
      console.error(error)
    })
}
